const { pageWrapper } = require(`~common/utils/root`)

export const wrapPageElement = pageWrapper
